import { BUTTON_FONT } from '../constants';
import ButtonContainer from 'core/button-container';
import hours from 'static/img/icons/24_hours.svg';
import Image from 'core/image';
import LandingSection from 'components/landing/components/landing-section';
import max from 'static/img/icons/CECA_Max_FaceColor.png';
import money from 'static/img/icons/money.svg';
import phone from 'static/img/icons/cellphone.svg';
import { PinkButton } from 'core/buttons/buttons';
import styles from 'styles/WhyCompare.module.scss';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useTranslations } from 'next-intl';

const WhyCompare = () => {
    const { seoText, verification } = useGetSeoTextByIndex('why_compare');
    const t = useTranslations('why-compare');

    if (!verification) {
        // TODO: Add sentry controlled exception
        return null;
    }

    return (
        <LandingSection>
            <div className={styles.top_image}>
                <Image src={max} width={100} height={100} alt={t('alt-image')} />
            </div>
            <Title colored align content={seoText.section_title} />
            <div className="paragraph_wrapper">
                <TextBox
                    title={seoText.item1.title}
                    content={seoText.item1.sentence1}
                    containerWidth="360px"
                    image={money}
                />
                <TextBox
                    title={seoText.item2.title}
                    content={seoText.item2.sentence1}
                    containerWidth="360px"
                    image={phone}
                />
                <TextBox
                    title={seoText.item3.title}
                    content={seoText.item3.sentence1}
                    containerWidth="360px"
                    image={hours}
                />
            </div>
            <Text
                content={seoText.paragraph1.sentence1}
                width="auto"
                marginTop="40px"
            />
            <Text
                content={seoText.paragraph2.sentence1}
                width="auto"
                marginBottom="40px"
            />
            <ButtonContainer>
                <PinkButton
                    label={`${t('button.label')} &#10095;`}
                    href={t('button.href')}
                    propsButton={BUTTON_FONT}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

export default WhyCompare;
